import CommonApi from '@/pages/api'
import { NewArrowIcon } from '@/src/assets/icons'
import Button from '@/src/components/button'
import { Box, Typography } from '@mui/material'
import { useStore } from '@/src/types/store'
import React, { useState } from 'react'

const BlockUserPage = ({ handleBack, blockedUserData, loading }: any) => {
  const [accessLoading, setAccessLoading] = useState(false)
  const { openToast } = useStore()

  const handleContactAdministrator = async () => {
    setAccessLoading(true)
    try {
      const resp = await CommonApi({
        path: `access-restriction-notify`,
        method: 'post',
        data: {
          email: blockedUserData?.email
        }
      })

      if (resp?.status) {
        openToast(resp?.msg ?? 'Your request has been sent to the administrator', 'success')
      }
    } catch (error: any) {
      openToast(error.response?.data?.msg ?? 'something went wrong!', 'error')
    }
    setAccessLoading(false)
  }
  return (
    <div>
      <Typography variant="h1" className="pb-8 pt-16 text-center">
        Access restricted
      </Typography>
      <Typography>We’re sorry, but it looks like access to your account</Typography>
      <Typography>{blockedUserData?.email || ''} has been temporarily restricted.</Typography>
      <Typography className="my-4 mb-8">
        To resolve this issue, please contact an administrator.
      </Typography>

      <Button
        loading={loading || accessLoading}
        fullwidth={true}
        text="Contact administrator"
        type="submit"
        onClick={handleContactAdministrator}
        extraClass="!normal-case"
      />
      <Box className="flex gap-2 w-full pt-6 justify-center sm:justify-start relative items-center">
        <Box onClick={() => handleBack(null)} className="flex items-center cursor-pointer">
          <NewArrowIcon className="fill-primary-main" />
          <Typography variant="buttonLink" color="primary.main">
            Back to Sign In page
          </Typography>
        </Box>
      </Box>
    </div>
  )
}

export default BlockUserPage
